import wfclonetimingPlot from "../../../../content/posts/blogs/2023/inkling/workflowtiming.jsx";
import * as React from 'react';
export default {
  wfclonetimingPlot,
  React
};